import React from "react";
import { useIntl, defineMessages } from "react-intl";
import { Link } from "react-router-dom";

import { useActionStyles } from "../mainHeader";
import IconButton from "@material-ui/core/IconButton";
import CalendarIcon from "../../common/icons/calendarIcon";

const messages = defineMessages({
    calenderTooltip: {
        id: "work-order-header.calendar-tooltip",
        defaultMessage: "Calender",
        description: "Calender work order header toottip",
    },
});

export const Help = (props) => {
    const intl = useIntl();
    const classes = useActionStyles();

    return (
        <IconButton aria-describedby="context-help" className={classes.menuButton} component={Link} to="/">
            <CalendarIcon color="white" title={intl.formatMessage(messages.calenderTooltip)} />
        </IconButton>
    );
};

export default Help;
